import { useEffect } from 'react'
import { App } from 'antd'
import { Effect } from 'effector'

type EffectConfig = {
  effect: Effect<any, any, any>
  successMessage: string
  errorMessage?: string
  onSuccess?: () => void
}

/**
 * Подписывается на done/fail эффекторных эффектов и показывает Antd toast.
 * Сообщение об ошибке берётся из `error.body.message`, если есть, иначе fallback.
 */
export const useEffectNotifications = (configs: EffectConfig[]) => {
  const { message } = App.useApp()
  useEffect(() => {
    const unsubs: Array<() => void> = []
    configs.forEach((config) => {
      unsubs.push(
        config.effect.done.watch(() => {
          message.success(config.successMessage)
          config.onSuccess?.()
        }),
      )
      unsubs.push(
        config.effect.fail.watch(({ error }) => {
          const msg =
            (error as any)?.body?.message ??
            config.errorMessage ??
            'Operation failed'
          message.error(msg)
        }),
      )
    })
    return () => unsubs.forEach((unsub) => unsub())
  }, [])
}
